// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"353":"contact","594":"about","652":"service","671":"services"}[chunkId] + "." + {"353":"76325bab","594":"0e60fa86","652":"c32da370","671":"1ae433dd"}[chunkId] + ".js";
};